import {
    aggregate_to_annual_average,
    load_capacity_factor_data,
} from "../capacity_factor_data"
import { CapacityFactorData } from "../interface"


export interface AllCapacityFactorData
{
    year: number
    wind: CapacityFactorData
    annual_wind: CapacityFactorData
    solar: CapacityFactorData
    annual_solar: CapacityFactorData
}

export async function promise_load_all_capacity_factor_data(): Promise<AllCapacityFactorData>
{
    const wind_turbine_capacity_data = await load_wind_turbine_capacity_data()
    const solar_pv_capacity_data = await load_solar_pv_capacity_data()

    const annual_wind = aggregate_to_annual_average(wind_turbine_capacity_data)
    const annual_solar = aggregate_to_annual_average(solar_pv_capacity_data)

    return {
        year: 2019,
        wind: wind_turbine_capacity_data,
        annual_wind,
        solar: solar_pv_capacity_data,
        annual_solar,
    }
}

async function load_wind_turbine_capacity_data(): Promise<CapacityFactorData>
{
    return load_capacity_factor_data("data/wind_turbine_capacity/_2019_uk_h3_res4.csv")
}

async function load_solar_pv_capacity_data(): Promise<CapacityFactorData>
{
    return load_capacity_factor_data("data/solar_pv_capacity/_2019_uk_h3_res4.csv")
}
